
<section>
	<ng-container *ngFor="let sal of ( salutacion$ | async )">
		<ng-container *ngIf="sal" [ngTemplateOutlet]="card" [ngTemplateOutletContext]="{salutacion:sal}"></ng-container>
	</ng-container>
</section>


<!-- Card -->
<ng-template #card let-salutacion="salutacion">
	<div class="card" (click)="onSalutacionSelected( salutacion )" [ngStyle]="getCardStyle( salutacion )" [ngClass]="getCardClasses( salutacion )">
		<div class="saludo">{{salutacion.saludo}}</div>
	</div>
</ng-template>